import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyAL5OkRba_n-iL59XdtOAd50TLzTCs6bxA',
  authDomain: 'project-project-30249.firebaseapp.com',
  projectId: 'project-project-30249',
  storageBucket: 'project-project-30249.firebasestorage.app',
  messagingSenderId: '133212118595',
  appId: '1:133212118595:web:ef5c33370404443e9abef6',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

const forceRemote = new URLSearchParams(window.location.search).get('remote') === 'true';
const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
export const useEmulator = isLocal && !forceRemote;

if (useEmulator) {
  if (import.meta.env.DEV) console.log('Connecting to Firebase Emulators at 127.0.0.1');
  connectAuthEmulator(auth, 'http://127.0.0.1:9099');
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
}

